import "./index.css";
import { useState, useEffect } from "react";
import { Select, notification } from "antd";
import { useAuth } from "../../context/auth";

const ProvinceDropdown = ({ setSelectedProvinces, ...props }) => {
  const { accessToken } = useAuth()

  const [provinces, setProvinces] = useState([]);
  useEffect(() => {
    async function getProvinces() {
      const url = new URL('/api/province', window.location);

      const res = await fetch(url, {
        headers: { 'X-ACCESS-TOKEN': accessToken },
      })
      if (res.ok) {
        const { provinces } = await res.json()
        setProvinces(provinces)
      } else {
        notification["error"]({
          message: "Something went wrong !",
          description: `Please re-login or contact web admin. (Code: ${await res.json().then(data => data.message)})`,
        });
      }
    }

    getProvinces()
  }, [accessToken]);

  return (
    <Select
      {...props}
      showSearch
      placeholder="Province"
      maxTagCount="responsive"
      maxTagPlaceholder={(ids) => `+ ${ids.length}`}
      optionFilterProp="children"
    >
      {setSelectedProvinces && (
        <div disabled={true}>
          <span
            onClick={() => setSelectedProvinces(provinces.map(province => province.id))}
            style={{
              display: "inline-block",
              color: "#286FBE",
              cursor: "pointer",
            }}
          >
            SELECT ALL
          </span>
        </div>
      )}
      {provinces.map(province => (
        <Select.Option key={province.id} value={province.id}>
          {province.nameEn}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ProvinceDropdown;
